var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMicRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.277,
    height: 21.665,
    viewBox: "0 0 16.277 21.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mic",
    d: "M4.07,21.654a1.354,1.354,0,0,1,0-2.708H6.782V17.471A8.133,8.133,0,0,1,0,9.474a1.357,1.357,0,0,1,2.714,0,5.425,5.425,0,0,0,10.851,0,1.356,1.356,0,1,1,2.712,0,8.133,8.133,0,0,1-6.782,8v1.475h2.712a1.354,1.354,0,0,1,0,2.708Zm0-12.18V4.06a4.069,4.069,0,1,1,8.137,0V9.474a4.069,4.069,0,0,1-8.137,0ZM6.782,4.06V9.474a1.356,1.356,0,1,0,2.712,0V4.06a1.356,1.356,0,0,0-2.712,0Z",
    transform: "translate(0 0.008)",
    fill: "#fd3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMicRed);
export default __webpack_public_path__ + "static/media/icon-mic-red.c58c3fa603f467b0778962061327b18f.svg";
export { ForwardRef as ReactComponent };